import type { PedigreeType } from '@application/types';
import type { CountryCode } from '@gql/graphql';
import type {
  BreedOverviewData,
  CardItemBreederData,
  CardItemLitterData,
  FiltersWithModalData,
  PaginationData,
  SelectOption,
  StoreCardItemPromoData,
} from '@presentation/components';
import type { LocationDescriptor } from 'history';
import type { ReactNode } from 'react';

export enum BreederListSortType {
  CONNECTION_ASC = 'CONNECTION_ASC',
  CONNECTION_DESC = 'CONNECTION_DESC',
  RATING_ASC = 'RATING_ASC',
  RATING_DESC = 'RATING_DESC',
}

export interface BreederListPageFormOptions {
  breeds: SelectOption<string>[];
  regions: SelectOption<string>[];
}

export interface BreederListPageFormValues {
  breedNames?: string[];
  levels?: string[];
  hasLitters?: boolean;
  pedigree?: PedigreeType[];
  spokenLanguages?: string[];
  countries?: CountryCode[];
  regions?: string[];
}

export interface BreederListPageData {
  items: (CardItemBreederData | StoreCardItemPromoData)[];

  formOptions: BreederListPageFormOptions;

  pagination: PaginationData;
  loading?: boolean;

  filtersModal: FiltersWithModalData;
  pageTitle: string;
  litterCategories: BreederListPageLitterCategory[];
  littersLoading: boolean;

  breedOverview?: BreedOverviewData;
  breedInteretBanner?: ReactNode;
}

export interface BreederListPageLitterCategory {
  label: string;
  litters?: CardItemLitterData[];
  canLoadMoreRelatedLitters?: boolean;
  link?: LocationDescriptor;
}

export interface BreederListPageProps extends BreederListPageData {}
